/**
* Dropdown Manager
* -----------------------------------------------------------------------------
* Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
*
* @constructor
* @namespace DropdownManager
*/

var modernizr = require("../../utilities/js/modernizr");
var hoverintent = require("hoverintent");
var Dropdown = require("../../navigation/js/dropdown");

function DropdownManager() {
    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 500;
    this.dropdowns = [];
    this.activeDropdown = undefined;
    this.events = window.PointerEvent ? {
        end:   "pointerup",
        enter: "pointerenter",
        leave: "pointerleave"
    } : {
        end: "touchend",
        enter: "mouseenter",
        leave: "mouseleave"
    };
}

DropdownManager.prototype = {
    register: function($trigger) {
        var dd = new Dropdown($trigger);
        var events = this.events;

        var opts = {
            // timeout: 500,
            // interval: 50
        };

        // Trigger events - the link that you interact with to display the dropdown
        if (modernizr.touchevents) {
            dd.$trigger.on(this.events.end, this.onTriggerTouchEnd.bind(this, dd));
        } else {
            hoverintent(
                dd.$trigger.get(0),
                this.onTriggerMouseEnter.bind(this, dd),
                this.onTriggerMouseLeave.bind(this, dd)
            ).options(opts);
        }

        // Dropdown events - what happens when you interact with the dropdown itself
        dd.$el.on(events.leave, this.onDropdownMouseLeave.bind(this, dd));
        dd.$el.on(events.enter, this.onDropdownMouseEnter.bind(this, dd));
        dd.$el.on(events.end,   this.onDropdownTouchEnd.bind(this, dd));

        this.dropdowns.push(dd);
    },
    onTriggerMouseEnter: function(dd, e) {
        if(e.pointerType != "touch") {
            this.stopCloseTimeout();
            this.openDropdown(dd);
        }
    },
    onTriggerMouseLeave: function(dd, e) {
        if(e.pointerType != "touch") {
            this.startCloseTimeout(dd);
        }
    },
    onTriggerTouchEnd: function(dd, e) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
        if(e.pointerType != "touch") {
            this.stopCloseTimeout();
        }
    },
    onDropdownMouseLeave: function(dd, e) {
        if(e.pointerType != "touch") {
            this.startCloseTimeout(dd);
        }
    },
    onDropdownTouchEnd: function(dd, e) {
        e.stopPropagation();
    },
    toggleDropdown: function(dd) {
        return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
        if(this.activeDropdown !== dd) {
            this.activeDropdown = dd;
            this.closeAllDropdowns();
            dd.open();
        }
    },
    closeDropdown: function(dd) {
        dd.close();

        if(this.activeDropdown == dd) {
            this.activeDropdown = undefined;
        }
    },
    closeAllDropdowns: function() {
        $.each(this.dropdowns, function(i, dd) {
            if(dd.isOpen()) {
                dd.close();
            }
        });
        this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
        this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
        clearTimeout(this.closeDropdownTimeout);
    }
};

module.exports = DropdownManager;



//////////////////
// WEBPACK FOOTER
// ./navigation/js/dropdownManager.js
// module id = 141
// module chunks = 3